// extracted by mini-css-extract-plugin
export default {"wrapper":"EasyToFindSection_wrapper__xtokL","overlay":"EasyToFindSection_overlay__zKuzK","icon":"EasyToFindSection_icon__uWHP4","title":"EasyToFindSection_title__SN-CZ"};